import * as React from "react";
const SvgClose = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M18 6L6 18M6 6L18 18", stroke: "#76A28D", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgClose;
